export var VelavuStreamUpdateTarget;
(function (VelavuStreamUpdateTarget) {
    VelavuStreamUpdateTarget["Event"] = "events";
    VelavuStreamUpdateTarget["Asset"] = "assets";
    VelavuStreamUpdateTarget["Device"] = "devices";
    VelavuStreamUpdateTarget["Site"] = "sites";
    VelavuStreamUpdateTarget["Geofence"] = "geofences";
    VelavuStreamUpdateTarget["Rule"] = "rules";
})(VelavuStreamUpdateTarget || (VelavuStreamUpdateTarget = {}));
export var VelavuStreamUpdateOperation;
(function (VelavuStreamUpdateOperation) {
    VelavuStreamUpdateOperation["Created"] = "created";
    VelavuStreamUpdateOperation["Updated"] = "updated";
    VelavuStreamUpdateOperation["Deleted"] = "deleted";
})(VelavuStreamUpdateOperation || (VelavuStreamUpdateOperation = {}));
//# sourceMappingURL=streamUpdate.js.map